/**
 * Read side of an MCE adapter's stored CDO (`Mce.Mapping`, identifier MCEM).
 *
 * The frontend never packs a Mapping: the converter builds it, LiftCloud
 * stores it, and this only reads what the editor displays. A stored Mapping
 * with an `idl` bundle is embedded (uploaded); one without is legacy. A legacy
 * row's IDL file and product are managed by support through the API, and only
 * its event mapping is edited here, against the copy kept in `savedEvent`.
 */
import * as flatbuffers from "flatbuffers";
import { bytesToBase64 } from "../../utils/base64";
import { Mapping } from "../generated/mce/mapping";
import { AdapterCdoMceInterface } from "../../interfaces/Adapter.interface";

function asText(value: string | Uint8Array | null | undefined): string {
  if (value == null) return "";
  return typeof value === "string" ? value : new TextDecoder().decode(value);
}

/** Editor state from stored CDO bytes, or null when they are not an MCEM buffer. */
export default function decodeStoredMceMapping(bytes: Uint8Array): AdapterCdoMceInterface | null {
  try {
    const buf = new flatbuffers.ByteBuffer(bytes);
    if (!Mapping.bufferHasIdentifier(buf)) return null;
    const t = Mapping.getRootAsMapping(buf).unpack();
    const event = {
      mapping_file: asText(t.eventMappingFile),
      mapping_data: asText(t.eventMappingData),
    };
    return {
      idl_file: asText(t.idlFile),
      product_type: t.productType,
      event,
      stored: {
        kind: t.idl ? "embedded" : "legacy",
        binaryBase64: bytesToBase64(bytes),
        savedEvent: { ...event },
      },
    };
  } catch {
    return null;
  }
}
